module.exports = __webpack_public_path__ + "img/projeto_vivo_acordos_de_cobranca2.6b66fbe4.jpg";